/**
 * ReportPdfStyledShell
 *
 * Renders its children (the existing ReportFull component) inside a
 * "printed page" look-and-feel: warm grey backdrop, stacked white
 * pages with soft drop shadows, generous interior padding, serif body
 * type. Used on mobile when the user picks "PDF view" — embedded PDFs
 * render unpredictably on mobile browsers, so we mimic the look with
 * real React content (which stays accessible, searchable, and shareable).
 *
 * No content changes — pure visual wrapper. Children render exactly as
 * they would in web view, just framed.
 */
export default function ReportPdfStyledShell({ children }) {
    return (
        <div
            className="bl-pdf-shell"
            data-testid="report-pdf-styled-shell"
            style={{
                background: "var(--bl-paper-tint, #ECE7DC)",
                padding: "16px 0",
                borderRadius: "12px",
            }}
        >
            <div
                className="mx-auto"
                style={{
                    maxWidth: "780px",
                    background: "#FFFFFF",
                    boxShadow:
                        "0 30px 60px -28px rgba(31,36,40,0.20), " +
                        "0 8px 18px -8px rgba(31,36,40,0.12)",
                    borderRadius: "6px",
                    padding: "32px 22px",
                    fontFamily:
                        "'Liberation Serif', Georgia, 'Times New Roman', serif",
                    color: "var(--bl-ink, #1F2428)",
                }}
            >
                {children}
            </div>
        </div>
    );
}
